import styled from 'styled-components';
import { mediaQuery } from '../../common/styles/styleUtil';

export const CommentWrapper = styled.div<{ isOnProjectPage: boolean }>`
  @media (${mediaQuery.tablet}) {
    padding: ${(props) => (props.isOnProjectPage ? '0 24px' : '0px')};
  }

  @media (${mediaQuery.mobile}) {
    padding: 0 16px;
    margin-bottom: 32px;
  }

  button {
    &.load-more {
      width: 236px;
      @media (${mediaQuery.mobile}) {
        border: none;
        text-align: left;
        box-shadow: none;
      }
      @media (${mediaQuery.tablet}) {
        border: 1px solid #2b6ed2;
        width: 100%;
        text-align: center;
      }
    }
  }
`;

export const TitleWrapper = styled.div`
  color: #333f48;
  font-size: 20px;
  font-weight: 400;
  line-height: 26px;
  margin: 0 0 16px;
`;

export const CommentContentWrapper = styled.div`
  margin-top: 32px;
  @media (${mediaQuery.mobile}) {
    margin-top: 24px;
  }
`;

export const SignedInUserWrapper = styled.div`
  margin-bottom: 10px;
`;

export const ShowMoreComment = styled.span`
  color: #2b6ed2;
  cursor: pointer;
  &::after {
    content: '';
    border: solid #2b6ed2;
    border-width: 0 1px 1px 0;
    display: inline-block;
    padding: 4px;
    margin-left: 8px;
    transform: rotate(45deg) translate(-1px, -1px);
  }
`;
